import {
  SET_TEMPLATES,
  SET_TEMPLATE_LIST,
  SET_SELECTED_TEMPLATE,
  SET_TEMPLATE_MAPS_LIST,
  SET_TEMPLATE_MAPS,
  SET_SELECTED_TEMPLATE_MAP,
} from './actions';
import { merge } from '@its/util';

export default (state = [], action) => {
  switch (action.type) {
    case SET_TEMPLATES:
      return merge(state, { items: action.payload });
    case SET_TEMPLATE_LIST:
      return merge(state, { list: action.payload });
    case SET_SELECTED_TEMPLATE:
      return merge(state, { detail: action.payload });
    case SET_TEMPLATE_MAPS:
      return merge(state, {
        maps: merge(state.maps, {
          items: action.payload,
        }),
      });
    case SET_TEMPLATE_MAPS_LIST:
      return merge(state, {
        maps: merge(state.maps, {
          lists: action.payload,
        }),
      });
    case SET_SELECTED_TEMPLATE_MAP:
      return merge(state, {
        maps: merge(state.maps, {
          detail: action.payload,
        }),
      });
    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/redux/template/reducer.js
 **/